// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockQlty_wrapper__U2UWB"};